import * as yup from 'yup';

const utilizationField = yup
  .number()
  .nullable()
  .integer('Must be an integer')
  .min(1, 'Must be at least 1')
  .max(10000, 'Must be 10000 or less')
  .default(null);

export const metricsValidationSchema = yup.object({
  cpu: utilizationField,
  memory: utilizationField,
});
